(() => {
  const THRESHOLDS = [25, 50, 75, 90];
  const MIN_PAGE_HEIGHT_FACTOR = 1.5;
  const EVENT_NAME = 'azullado:scroll_depth';

  if (window.Shopify?.designMode) return;
  if (/^\/checkouts?(?:\/|$)/i.test(window.location.pathname)) return;

  const sentThresholds = new Set();
  const pendingThresholds = new Set();
  let ticking = false;
  let retryTimer = null;

  function getDocumentHeight() {
    return Math.max(
      document.body?.scrollHeight || 0,
      document.documentElement?.scrollHeight || 0,
      document.body?.offsetHeight || 0,
      document.documentElement?.offsetHeight || 0,
      document.body?.clientHeight || 0,
      document.documentElement?.clientHeight || 0
    );
  }

  function isLongEnough() {
    return getDocumentHeight() >= window.innerHeight * MIN_PAGE_HEIGHT_FACTOR;
  }

  function getScrollPercent() {
    const documentHeight = getDocumentHeight();
    const scrollableHeight = Math.max(documentHeight - window.innerHeight, 1);
    const scrollTop = Math.max(
      0,
      window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0
    );

    return Math.min(100, Math.max(0, (scrollTop / scrollableHeight) * 100));
  }

  function canPublish() {
    return Boolean(
      window.Shopify?.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    );
  }

  function publishThreshold(threshold) {
    if (sentThresholds.has(threshold)) return true;

    if (!canPublish()) {
      pendingThresholds.add(threshold);
      scheduleRetry();
      return false;
    }

    try {
      window.Shopify.analytics.publish(EVENT_NAME, {
        event_action: 'Schwelle erreicht',
        metric_name: `${threshold} %`,
        metric_value: threshold,
        scroll_percent: threshold,
        source: 'global-scroll-depth',
        page_path: window.location.pathname
      });

      sentThresholds.add(threshold);
      pendingThresholds.delete(threshold);
      return true;
    } catch (error) {
      pendingThresholds.add(threshold);
      scheduleRetry();
      return false;
    }
  }

  function flushPending() {
    retryTimer = null;

    if (!pendingThresholds.size) return;

    Array.from(pendingThresholds)
      .sort((a, b) => a - b)
      .forEach((threshold) => publishThreshold(threshold));

    if (pendingThresholds.size) scheduleRetry();
  }

  function scheduleRetry() {
    if (retryTimer !== null) return;
    retryTimer = window.setTimeout(flushPending, 750);
  }

  function checkThresholds() {
    ticking = false;
    if (!isLongEnough()) return;

    const currentPercent = getScrollPercent();

    THRESHOLDS.forEach((threshold) => {
      if (currentPercent >= threshold && !sentThresholds.has(threshold)) {
        publishThreshold(threshold);
      }
    });

    if (sentThresholds.size === THRESHOLDS.length) {
      removeListeners();
    }
  }

  function requestCheck() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(checkThresholds);
  }

  function removeListeners() {
    window.removeEventListener('scroll', requestCheck);
    window.removeEventListener('resize', requestCheck);
    window.removeEventListener('orientationchange', requestCheck);
  }

  window.addEventListener('scroll', requestCheck, { passive: true });
  window.addEventListener('resize', requestCheck, { passive: true });
  window.addEventListener('orientationchange', requestCheck, { passive: true });

  window.addEventListener('pagehide', () => {
    removeListeners();
    if (retryTimer !== null) window.clearTimeout(retryTimer);
  }, { once: true });

  requestCheck();
})();
